import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ui';
import { ui } from 'constants/config';
import Table from 'components/shared/table';

const GradingStationTableFooter = props => {
  const {
    itemsToGrade,
    loading,
    setPage,
    page,
    setRowsPerPage,
    rowsPerPage,
    pageCount,
    query,
  } = props;

  if (loading || (!itemsToGrade.length && page === 1 && !query)) return null;

  const renderOption = option => (
    <option key={option} value={option} children={option} />
  );

  return (
    <Table.Footer className="p-24">
      <Table.Pagination
        onPageChange={setPage}
        page={page}
        pageCount={pageCount}
      />
      <span className="fz-16 w-fill d-f jc-e ai-c">
        <label htmlFor="per-page" className="u-showBelowMD mr-4 mb-0">
          {t('common.per_page')}
        </label>
        <label htmlFor="per-page" className="u-hideBelowMD mr-4 mb-0">
          {t('common.rows_per_page')}
        </label>
        <div className="SelectWithArrows">
          <select
            id="per-page"
            className="NewButton NewButton--white w-110"
            onChange={setRowsPerPage}
            value={rowsPerPage}
            children={ui.INDEX_ROWS_PER_PAGE.map(renderOption)}
          />
          <Icon name="select_arrows" />
        </div>
      </span>
    </Table.Footer>
  );
};

GradingStationTableFooter.propTypes = {
  loading: PropTypes.bool,
  setPage: PropTypes.func,
  page: PropTypes.number,
  setRowsPerPage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  itemsToGrade: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      title: PropTypes.string,
      email: PropTypes.string,
    }),
  ),
};

export default GradingStationTableFooter;
